import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BlankPipe } from './blank.pipe';
import { YesNoBlankPipe } from './yes-no-blank.pipe';
import { YesNoPipe } from './yes-no.pipe';
import { SafeHtmlPipe } from './safe-html.pipe';
import { PercentagePipe } from './percentage.pipe';

@NgModule({
  declarations: [BlankPipe, YesNoBlankPipe, YesNoPipe, SafeHtmlPipe, PercentagePipe],
  imports: [
    CommonModule
  ],
  exports: [BlankPipe, YesNoBlankPipe, YesNoPipe, SafeHtmlPipe, PercentagePipe ]
})
export class SharedPipesModule { }
